import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-contact-states-skill-cell-renderer',
    templateUrl: './contact-states-skill-cell-renderer.component.html',
    styleUrls: ['./contact-states-skill-cell-renderer.component.scss']
})
export class ContactStatesSkillCellRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    contactStates: string[] = ['Pre Queue', 'In Queue', 'Active', 'On Hold', 'Post Agent'];

    constructor() { }

    agInit(params: ICellRendererParams) {
        this.params = params;
        if (this.params.data.Total > this.params.context.largestStateTotal) {
            this.params.context.largestStateTotal = this.params.data.Total;
        }
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        if (this.params.data.Total > this.params.context.largestStateTotal) {
            this.params.context.largestStateTotal = this.params.data.Total;
        }
        return true;
    }

    getStateColor(state: string) {
        return this.params.context.getStateColor(state);
    }

    getLocalizedStateName(state: string) {
        return this.params.context.getLocalizedStateName(state);
    }
}
